import { useEffect, useState } from 'react'

export const MEDIA_BREAKS = {
  X_LARGE: 'xl',
  LARGE: 'lg',
  MEDIUM: 'md',
  SMALL: 'sm',
  X_SMALL: 'xs',
}

export interface Breakpoints {
  xs: boolean
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
}

export const useMediaBreakPoints = () => {
  const [breakpoints, setBreakpoints] = useState<Breakpoints>({
    xs: false, // Extra Small
    sm: false, // Small
    md: false, // Medium
    lg: false, // Large
    xl: false, // Extra Large
  })

  useEffect(() => {
    const updateBreakpoints = () => {
      const xs = window.matchMedia('(max-width: 575.98px)').matches
      const sm = window.matchMedia('(min-width: 576px)').matches
      const md = window.matchMedia('(min-width: 768px)').matches
      const lg = window.matchMedia('(min-width: 992px)').matches
      const xl = window.matchMedia('(min-width: 1200px)').matches
      setBreakpoints({ xs, sm, md, lg, xl })
    }

    // Initial call to set the initial values
    updateBreakpoints()

    // Listen for changes in window size and update breakpoints accordingly
    window.addEventListener('resize', updateBreakpoints)

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateBreakpoints)
    }
  }, [])

  return breakpoints
}
